<template>
    <div class="usrpro" :class="isShow==false? '':'position-fixed'">
        <BHeader :title="$t('common.usrpro')" :isLogin="true" back="/usracc" :isInUserAccount="true"/>
        <div class="box">
            <div :class="editEmail==false ? 'edit-table' : 'email-edit-table' ">
                <div>
                    <div class="text-inline">
                        <div class="table-text-1">{{$t("usrpro.usrMlAdr")}}</div>
                        <div class="table-text-1-1">（{{$t("common.required")}}）</div>
                    </div>
                    <div v-if="!editEmail" :class="model.usrMlAdr == '' ? 'table-text-3' : 'table-text-2'"
                      style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                      {{model.usrMlAdr == '' ? $t("common.unselected") : model.usrMlAdr}}
                    </div>
                    <div v-if="editEmail" class="edit-save">
                        <div class="input-style">
                            <BFormInput id="input-live" v-model="model.usrMlAdr" type="text" maxlength="128"
                            :state="emailFeedBack==null" aria-describedby="input-live-feedback" trim></BFormInput>
                            <BImg :src="clear" style="position: absolute;top:11px;right:22px" @click="model.usrMlAdr = ''" v-show="model.usrMlAdr!=''"></BImg> 
                        </div>
                        <div @click="updateUsrPro('usrMlAdr');editEmail=false" v-show="editEmail" v-bind:class="emailFeedBack ? 'text' : 'saveText'" >{{$t("usrpro.save")}}</div>
                    </div>
                    <div v-if="emailFeedBack"  class="feedback">{{emailFeedBack}}</div>
                </div>
                <BImg :src="edit" alt="edit" @click="editEmail=!editEmail;" v-show="!editEmail"></BImg>
            </div>
            <div class="outline"></div>
        </div>

        <div class="box">
            <div v-bind:class="editEmailEx == false ? 'edit-table' : 'email-edit-table'">
                <div>
                    <div class="text-inline">
                        <div class="table-text-1">{{$t("usrpro.usrMlAdrEx")}}</div>
                    </div>
                    <div v-if="!editEmailEx" :class="model.usrMlAdrEx == '' ? 'table-text-3' : 'table-text-2'"
                      style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                      {{model.usrMlAdrEx == '' ? $t("common.unselected") : model.usrMlAdrEx}}
                    </div>
                    <div v-if="editEmailEx" class="edit-save">
                        <div class="input-style">
                            <BFormInput id="input-live" v-model="model.usrMlAdrEx" :state="emailExFeedBack ==null " aria-describedby="input-live-feedback" type="text" maxlength="128" trim></BFormInput>
                            <BImg :src="clear" style="position: absolute;top:11px;right:22px" @click="model.usrMlAdrEx = ''" v-show="model.usrMlAdrEx!=''"></BImg> 
                        </div>
                        <div @click="updateUsrPro('usrMlAdrEx');editEmailEx = false" v-show="editEmailEx" v-bind:class="emailExFeedBack ? 'text' : 'saveText'">{{$t("usrpro.save")}}</div>
                    </div>
                    <div v-if="emailExFeedBack"  class="feedback">{{emailExFeedBack}}</div>
                </div>
                <BImg :src="edit" alt="edit" @click="editEmailEx=!editEmailEx;" v-show="!editEmailEx"></BImg>
            </div>
            <div class="outline"></div>
        </div>
        <div v-if="userProjectShowFlag">
            <div class="box">
                <div v-bind:class="editGender == false ? 'edit-table' : 'gender-edit-table'">
                    <div>
                        <div class="table-text-1">{{$t("usrpro.usrSex")}}</div>
                        <div v-if="!editGender" :class="model.usrSex === '' ? 'table-text-3' : 'table-text-2'"
                        style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                        {{model.usrSex === '' ? $t("common.unselected"):model.usrSex == 0 ? $t("usrpro.male") : $t("usrpro.female")}}
                        </div>
                        <div v-if="editGender" class="select-text-inline">
                            <b-form-select v-model="model.usrSex" :options="sexOptions"></b-form-select>
                            <div class="save-text" @click="updateUsrPro('usrSex');editGender=false" v-show="editGender" style="padding-right: 6px;">{{$t("usrpro.save")}}</div>
                        </div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editGender=!editGender" v-show="!editGender"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div :class="editBirthDate==false ? 'edit-table' : 'birthDate-edit-table'">
                    <div align="start">
                        <div class="table-text-1">{{$t("usrpro.usrBirthDate")}}</div>
                        <div v-if="!editBirthDate" :class="model.usrBirthDate == '' ? 'table-text-3' : 'table-text-2'"
                        style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                        {{model.usrBirthDate == null ? $t("common.unselected") : showBirthDate()}}
                        </div>
                        <div v-if="editBirthDate" class="brithDate-input">
                            <BFormInput type="date" v-model="model.usrBirthDate" max="9999-12-31"></BFormInput>
                            <div class="table-text-2" @click="updateUsrPro('usrBirthDate');editBirthDate = false" v-show="editBirthDate" style="padding-right: 6px">{{$t("usrpro.save")}}</div>
                        </div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editBirthDate=!editBirthDate" v-show="!editBirthDate"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div v-bind:class="editTel == false ? 'edit-table' : 'email-edit-table'">
                    <div>
                        <div class="text-inline">
                            <div class="table-text-1">{{$t("usrpro.usrTel")}}</div>
                        </div>
                        <div v-if="!editTel" :class="model.usrTel == '' ? 'table-text-3' : 'table-text-2'"
                        style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                        {{model.usrTel == '' ? $t("common.unselected") : model.usrTel}}
                        </div>
                        <div v-if="editTel" class="edit-save">
                            <div class="input-style">
                                <BFormInput id="input-live" v-model="model.usrTel" :state="telFeedBack == null" aria-describedby="input-live-feedback" type="text" maxlength="32" trim></BFormInput>
                                <BImg :src="clear" style="position: absolute;top:11px;right:22px" @click="model.usrTel = ''" v-show="model.usrTel!=''"></BImg> 
                            </div>
                            <div @click="updateUsrPro('usrTel');editTel =false" v-show="editTel" v-bind:class="telFeedBack ? 'text' : 'saveText'" >{{$t("usrpro.save")}}</div>
                        </div>
                        <div v-if="telFeedBack"  class="feedback">{{telFeedBack}}</div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editTel=!editTel" v-show="!editTel"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div :class="editAdr==false && zipFeedBack ? 'edit-table' : 'adr-edit-table'">
                    <div class="table-text-1" v-if="editAdr==true">{{$t("usrpro.usrAdr")}}</div>
                    <div :style="editAdr==true?'display: flex;':''">
                        <div class="table-text-1" v-if="editAdr==false">{{$t("usrpro.usrAdr")}}</div>
                        <div v-if="!editAdr && zipFeedBack" :class="model.usrAdr == '' ? 'table-text-3' : 'table-text-2'" style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                            {{model.usrAdr == '' ? $t("common.unselected") : model.usrAdr}}
                        </div>
                        <div v-else style="width:100%">
                            <div class="adr-text-1">{{$t("usrpro.usrZip")}}</div>
                            <div class="input-inline">
                                <div style="position: relative;">
                                    <BFormInput id="input-live" class="adr-input-1" placeholder="0000000" v-model="model.usrZip" :state="zipFeedBack" aria-describedby="input-live-feedback input-live-help" type="text" trim></BFormInput>
                                    <BImg :src="clear" style="position: absolute;top:11px;right:12px" @click="model.usrZip = ''" v-show="model.usrZip != ''"></BImg> 
                                </div>
                                <BButton @click="addressSearch()" style="margin-right: 0px;word-break: keep-all;">{{$t("usrpro.adr_search")}}</BButton>
                            </div>
                            <div v-if="!zipFeedBack" class="feedback">{{$t("message.zip_code_format")}}</div>
                            <BFormText id="input-live-help" style="display:flex">※{{$t("usrpro.usrzip_example")}}</BFormText>
                            <div class="adr-text-1">{{$t("usrpro.usrAdr")}}</div>
                            <div class="input-inline-1" style="position:relative;">
                                <BFormInput :class="adrFeedBack != '' ? 'error-border':'adr-input-2'" v-model="model.usrAdr" type="text" maxlength="128"></BFormInput>
                                <BImg :src="clear" style="position: absolute;top:11px;right:8px" @click="model.usrAdr = ''" v-show="model.usrAdr!=''"></BImg> 
                            </div>
                            <div v-if="adrFeedBack" class="feedback">{{ adrFeedBack }}</div>
                        </div>
                    </div>
                    <div v-if="editAdr || !zipFeedBack"><div @click="updateUsrPro('usrAdr');editAdr = false" v-bind:class="zipFeedBack==false || adrFeedBack != '' ? 'adr-text-2' : 'save-adr-text-2'" style="flex: 1;top:8px">{{$t("usrpro.save")}}</div></div>
                    <BImg :src="edit" alt="edit" @click="editAdr=!editAdr" v-show="!editAdr && zipFeedBack"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div v-bind:class="editNmKna == false ? 'edit-table' : 'email-edit-table'">
                    <div>
                        <div class="text-inline">
                            <div class="table-text-1">{{$t("usrpro.post")}}</div>
                        </div>
                        <div v-if="!editNmKna" :class="model.post == '' ? 'table-text-3' : 'table-text-2'" style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                            {{model.post == '' ? $t("common.unselected") : model.post}}
                        </div>
                        <div v-if="editNmKna" class="edit-save">
                            <div class="input-style">
                                <BFormInput id="input-live" v-model="model.post" :class="postFeedBack != '' ? 'error-border':''" type="text" maxlength="32" trim></BFormInput>
                                <BImg :src="clear" style="position: absolute;top:11px;right:22px" @click="model.post = ''" v-show="model.post != ''"></BImg> 
                            </div>
                            <div @click="updateUsrPro('post');editNmKna = false" v-bind:class="postFeedBack != '' ? 'text' : 'saveText'">{{$t("usrpro.save")}}</div>
                        </div>
                        <div v-if="editNmKna && postFeedBack" class="feedback">{{ postFeedBack }}</div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editNmKna=!editNmKna;" v-show="!editNmKna"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div v-bind:class="editType == false ? 'edit-table' : 'gender-edit-table'">
                    <div>
                        <div class="table-text-1">{{$t("usrpro.usrmstObject")}}</div>
                        <div v-if="!editType" :class="model.usrmstObject === '' ? 'table-text-3' : 'table-text-2'" style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                            {{showManageFlg()}}
                        </div>
                        <div v-if="editType" class="select-text-inline">
                            <b-form-select v-model="model.usrmstObject" :options="typeOptions"></b-form-select>
                            <div class="save-text" @click="updateUsrPro('usrmstObject');editType = false" v-show="editType" style="padding-right:6px">{{$t("usrpro.save")}}</div>
                        </div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editType=!editType" v-show="!editType"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div v-bind:class="editWorkDate==false ? 'edit-table' : 'birthDate-edit-table'">
                    <div>
                        <div class="table-text-1">{{$t("usrpro.work_start_date")}}</div>
                        <div v-if="!editWorkDate" :class="model.startWorkDate == '' ? 'table-text-3' : 'table-text-2'"
                        style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                        {{model.startWorkDate == null ? $t("common.unselected") : showWorkDate()}}
                        </div>
                        <div v-if="editWorkDate" class="brithDate-input">
                            <input  type="month" v-model="model.startWorkDate" max="9999-12"/>
                            <div class="table-text-2" @click="updateUsrPro('startWorkDate'); editWorkDate=false" v-show="editWorkDate" style="padding-right: 6px">{{$t("usrpro.save")}}</div>
                        </div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editWorkDate=!editWorkDate;" v-show="!editWorkDate"></BImg>
                </div>
                <div class="outline"></div>
            </div>

            <div class="box">
                <div v-bind:class="editMailFlg == false ? 'edit-table' : 'mailFlg-edit-table'">
                    <div>
                        <div class="table-text-1">{{$t("usrpro.mail_management")}}</div>
                        <div v-if="!editMailFlg" :class="model.mailFlg == null ? 'table-text-3' : 'table-text-4'"
                        style="white-space:nowrap; text-overflow: ellipsis;overflow:hidden;text-align: left; width:300px">
                        {{model.mailFlg == null ? $t("common.unselected") : model.mailFlg== true ? $t('usrpro.mail_accept'): $t('usrpro.mail_not_accept')}}
                        </div>
                        <div v-if="editMailFlg" class="button-inline">
                            <BButtonGroup>
                                <div class="wrapper" style="margin-right:8px">
                                    <BButton class="first-button" :class="model.mailFlg==true ? 'onClick':''" @click="model.mailFlg=true">
                                        {{$t("usrpro.mail_accept")}}
                                    </BButton>
                                    <BImg :src="model.mailFlg==true ? selectActive : select" alt="select" class="select"></BImg>
                                </div>
                                <div class="wrapper">
                                    <BButton class="middle-button" :class="model.mailFlg!=true  ? 'onClick':''" @click="model.mailFlg=false">
                                        {{$t("usrpro.mail_not_accept")}}
                                    </BButton>
                                    <BImg :src="model.mailFlg!=true ? selectActive : select" alt="select" class="select"></BImg>
                                </div>
                            </BButtonGroup>
                            <div class="save-text" @click="updateUsrPro('mailFlg');editMailFlg=false" v-show="editMailFlg">{{$t("usrpro.save")}}</div>
                        </div>
                    </div>
                    <BImg :src="edit" alt="edit" @click="editMailFlg=!editMailFlg" v-show="!editMailFlg"></BImg>
                </div>
                <div class="outline"></div>
            </div>
        </div>

        <BFooter whichPage="1" />

        <BOverlay :show="isShow" z-index=1031 no-wrap fixed opacity=0 >
            <template #overlay>
                <BCard no-body class="alert-card">
                    <BImg :src="alert" alt="alert"></BImg>
                    <div class="card-text">{{$t("message.save")}}</div>
                    <BButton class="btn1" @click="isExitWithoutSave=0">{{$t("message.saveYes")}}</BButton>
                    <BButton class="btn2" @click="isExitWithoutSave=1">{{$t("message.saveNo")}}</BButton>
                    <BButton class="btn3" @click="isShow=false">{{$t("common.cancel")}}</BButton>
                </BCard>
            </template>
        </BOverlay>
        
    </div>


</template>

<script>
import BHeader from '@/views/header.vue'
import BFooter from '@/views/footer.vue'
import { ref, inject, computed, onMounted, watch } from 'vue'
import CustomMessenger from '@/utils/custom_show.js'
import { onBeforeRouteLeave,useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { email, validate } from '../../../utils/validate_cont.js'

export default {
    name: 'usrpro',
    components: {
        BHeader,
        BFooter,
    },
    setup () {
        gtag('event', 'viewEditAccount', {
            'event_name': 'view'
        })
        const mailCheckFlg1 = ref(true);
        const mailCheckFlg2 = ref(true);
        const model = ref({})
        const initModel = ref({})
        const service = inject("service")
        const isShow = ref(false)
        const { t } = useI18n()
        const usrAdrCheckFlg = ref(true)
        const postCheckFlg = ref(true)
        const emailFeedBack = computed(() => {
            let regExp = /^(.+)@(.+)$/
            if(model.value.usrMlAdr == '' || model.value.usrMlAdr == null){
                return t("message.email1_required")
            }else if(model.value.usrMlAdr.length > 128){
                return t("message.email1_length")
            }else if(!regExp.test(model.value.usrMlAdr)){
                return t("message.email1_format")
            }else{
                mailCheck(model.value.usrMlAdr, mailCheckFlg1)
                if (!mailCheckFlg1.value) {
                    return t("message.email1_rfc")
                } else {
                    return null;
                }
            }
        })
            
        const emailExFeedBack = computed(function() {
            let regExp = /^(.+)@(.+)$/
            if(model.value.usrMlAdrEx == null || model.value.usrMlAdrEx==''){
            }
            else if(model.value.usrMlAdrEx.length > 128){
                return t("message.email2_length")
            }else if(!regExp.test(model.value.usrMlAdrEx)){
                return t("message.email2_format")
            }else {
                mailCheck(model.value.usrMlAdrEx, mailCheckFlg2)
                if (!mailCheckFlg2.value) {
                    return t("message.email2_rfc")
                } else {
                    return null;
                }
            }
        })

        /**
         * メールアドレスの検証
         * @param {value} 要求されたデータ 
         * @param {flag} エラーメッセージ表示フラグ
         */
        async function mailCheck(value, flag) {
            const validateData = { invalidStr: value }
            const res = await email(validateData)
            if (res.code == 201) {
                flag.value = false;
            } else if (res.code == 200) {
                flag.value = true;
            }
        }

        /**
         * メールアドレスの検証
         * @param {value} 要求されたデータ 
         * @param {flag} エラーメッセージ表示フラグ
         */
         async function invailStrCheck(value, flag) {
            const validateData = { invalidStr: value, isUnicoe: true }
            const res = await validate(validateData)
            if (res.code == 201) {
                flag.value = false;
            } else if (res.code == 200) {
                flag.value = true;
            }
        }
        const telFeedBack = computed(()=>{
            let regExp = /^[0-9]+\-{0,1}[0-9]+\-{0,1}[0-9]+$/
            if(model.value.usrTel == null || model.value.usrTel == ''){
                return null
            }else if(!regExp.test(model.value.usrTel)){
                return t("message.tel_format")
            }else if(model.value.usrTel.length > 32){
                return t("message.tel_length")
            }else{
                return null
            }
        })

        const zipFeedBack = computed(() => {
            let zipCode = model.value.usrZip
            if(zipCode){
                var tempZipCode = []
                for(var i=0;i<zipCode.length;i++){
                    var temp = zipCode[i]
                    if(temp != '-'){
                        tempZipCode.push(temp)
                    }
                }
                zipCode = tempZipCode.join('')
            }
            let pattern = /^[0-9]*$/
            if(zipCode){
                if(pattern.test(zipCode) && zipCode.length == 7) {
                    return true
                } else {
                    return false
                }
            }
            return true
        })

        /**
        * @description 計算プロパティ 住所検証
        * @method
        */
        const adrFeedBack = computed(()=>{
            
            if(!/^[^ -~｡-ﾟ]*$/.test(model.value.usrAdr)){
                return t("message.full_verb",{name:t("usrpro.usrAdr")})
            } else {
                invailStrCheck(model.value.usrAdr, usrAdrCheckFlg)
                if (!usrAdrCheckFlg.value) {
                    return "住所に使用できない文字が含まれています。"
                } else {
                    return "";
                }
            }

        })

                /**
        * @description 計算プロパティ 住所検証
        * @method
        */
        const postFeedBack = computed(()=>{
            if(!/^[^ -~｡-ﾟ]*$/.test(model.value.post)){
                return t("message.full_verb",{name:t("usrpro.post")})
            } else {
                invailStrCheck(model.value.post, postCheckFlg)
                if (!postCheckFlg.value) {
                    return "役職に使用できない文字が含まれています。"
                } else {
                    return "";
                }
            }
            
        })

        const editEmail = ref(false)
        const editEmailEx = ref(false)
        const editGender = ref(false)
        const editBirthDate = ref(false)
        const editWorkDate = ref(false)
        const editMailFlg = ref(false)
        const editTel = ref(false)
        const editAdr = ref(false)
        const editNmKna = ref(false)
        const editType = ref(false)

        const sexOptions = [
            {value: "", text: t("usrpro.nosetting")},
            {value: 0, text: t("usrpro.male")},
            {value: 1, text: t("usrpro.female")},
        ]
        const typeOptions = [
            {value: "", text: t("usrpro.nosetting")},
            {value: 2, text: t('usrpro.usrmstObjects0')},
            {value: 3, text: t('usrpro.usrmstObjects1')},
            {value: 4, text: t('usrpro.usrmstObjects2')},
            {value: 6, text: t('usrpro.usrmstObjects3')},
            {value: 5, text: t('usrpro.usrmstObjects4')},
        ]


        onMounted(() => {
            getUsrPro()
        })
        
        let flag = 0
        const userProjectShowFlag = ref(false)
        function getUsrPro() {
            service.usrpro.get().then((res) => {
                userProjectShowFlag.value = res.userProjectShowFlag
                if(0 == flag++){
                    model.value = {...res}
                    if(model.value.usrSex == null){
                        model.value.usrSex = ""
                    }
                    if(model.value.usrmstObject == null){
                        model.value.usrmstObject = ""
                    }
                }   
                initModel.value = {...res}
                if(initModel.value.usrSex == null){
                    initModel.value.usrSex = ""
                }
                if(initModel.value.usrmstObject == null){
                    initModel.value.usrmstObject = ""
                }
            })
        }

        function updateUsrPro(item) {
            let flag = checkData(item)
            if(!flag){
                return false
            }else{
                if('usrMlAdr' == item){
                    initModel.value.usrMlAdr = model.value.usrMlAdr
                }else if('usrMlAdrEx' == item){
                    initModel.value.usrMlAdrEx = model.value.usrMlAdrEx
                }else if('usrSex' == item){
                    initModel.value.usrSex = model.value.usrSex
                }else if('usrBirthDate' == item){
                    initModel.value.usrBirthDate = model.value.usrBirthDate
                    initModel.value.year = initModel.value.usrBirthDate.substring(0, 4)
                    initModel.value.month = initModel.value.usrBirthDate.substring(5, 7)
                    initModel.value.day = initModel.value.usrBirthDate.substring(8, 10)
                }else if('usrTel' == item){
                    initModel.value.usrTel = model.value.usrTel
                }else if('usrAdr' == item){
                    initModel.value.usrZip = model.value.usrZip
                    initModel.value.usrAdr = model.value.usrAdr
                }else if('post' == item){
                    initModel.value.post = model.value.post
                }else if('usrmstObject' == item){
                    initModel.value.usrmstObject = model.value.usrmstObject
                }else if('startWorkDate' == item){
                    initModel.value.startWorkDate = model.value.startWorkDate
                    initModel.value.workYear = model.value.workYear
                    initModel.value.workMonth = model.value.workMonth
                }else if('mailFlg' == item){
                    initModel.value.mailFlg = model.value.mailFlg
                }else{
                    initModel.value = model.value
                }
                if(model.value.usrSex === ""){
                    initModel.value.usrSex = null
                }
                if(model.value.usrmstObject === ""){
                    initModel.value.usrmstObject = null
                }
                service.usrpro.update(initModel.value).then((res) => {
                    getUsrPro()
                })
                return true
            }
            

        }

        function checkData(item){
            let flag = true
            if(item == null){
                if (emailFeedBack.value != null) {
                    flag = false
                }
                if (emailExFeedBack.value !=null) {
                    flag = false
                }
                if (telFeedBack.value != null) {
                    flag = false
                }
                if (zipFeedBack.value == false){
                    flag = false
                }
                if (adrFeedBack.value != ""){
                    flag = false
                }
                if (postFeedBack.value != ""){
                    flag = false
                }
            }else{
                if('usrMlAdr' == item && emailFeedBack.value != null){
                    flag = false
                }else if('usrMlAdrEx' == item && emailExFeedBack.value !=null){
                    flag = false
                }else if('usrTel' == item && telFeedBack.value != null){
                    flag = false
                }else if('usrAdr' == item && zipFeedBack.value == false || ('usrAdr' == item && adrFeedBack.value != '')){
                    flag = false
                }else if('post' == item && postFeedBack.value != ""){
                    flag = false
                }
            }
            if (model.value.usrBirthDate) {
                model.value.year = model.value.usrBirthDate.substring(0, 4)
                model.value.month = model.value.usrBirthDate.substring(5, 7)
                model.value.day = model.value.usrBirthDate.substring(8, 10)
                if (model.value.month != '10') {
                    model.value.month = model.value.month.replace('0', '')
                }
                if (model.value.day != '10') {
                    model.value.day = model.value.day.replace('0', '')
                }
            }
            if (model.value.startWorkDate) {
                model.value.workYear = model.value.startWorkDate.substring(0, 4)
                model.value.workMonth = model.value.startWorkDate.substring(5, 7)
                if(model.value.startWorkDate.length ==7){
                    model.value.startWorkDate = model.value.startWorkDate + '-01'
                }
                if (model.value.workMonth != '10') {
                    model.value.workMonth = model.value.workMonth.replace('0', '')
                }
            }          
            return flag
        }         



        function addressSearch() {
            let zipCode =model.value.usrZip.replace('-', '')
            service.common.researchZip(zipCode).then((res) => {
                const zipData = res
                if (!zipCode) {
                    CustomMessenger({
                    message: t("message.post_search_error"),
                    status: false
                    })
                } else if (!zipData) {
                    CustomMessenger({
                    message: t("message.post_search_error"),
                    status: false
                    })
                } else {
                    model.value.usrAdr = zipData.address1 + zipData.address2 + zipData.address3
                }
                }).catch((error) => {
                CustomMessenger({
                    message: t("message.post_search_error"),
                    status: false
                })
            })
        }

        function showBirthDate() {
            const birthDate = String(model.value.usrBirthDate);
            if (birthDate == '') {
                return birthDate
            }
            return birthDate.substring(0,4) + t("common.year")
            + birthDate.substring(5,7) + t("common.month")
            + birthDate.substring(8,10) + t("common.day")
        }
        function showWorkDate() {
            const workDate = String(model.value.startWorkDate);
            if (workDate == '') {
                return workDate
            }
            return workDate.substring(0,4) + t("common.year")
            + workDate.substring(5,7) + t("common.month")
        }

        function showManageFlg() {
            if(model.value.usrmstObjects != null) {
                if(model.value.usrmstObject === 2) {
                    return t("usrpro.usrmstObjects0")
                } else if (model.value.usrmstObject === 3) {
                    return t("usrpro.usrmstObjects1")
                } else if (model.value.usrmstObject === 4) {
                    return t("usrpro.usrmstObjects2")
                } else if (model.value.usrmstObject === 6) {
                    return t("usrpro.usrmstObjects3")
                } else if (model.value.usrmstObject === 5) {
                    return t("usrpro.usrmstObjects4")
                } else {
                    return t("common.unselected")
                }
            }
        }

        const isExitWithoutSave = ref()
        const router = useRouter()
        const toRouter = ref()

        onBeforeRouteLeave((to,from,next)=>{
            model.value.lstEntDtm = initModel.value.lstEntDtm
            if(JSON.stringify(model.value.startWorkDate).substring(1,11) == JSON.stringify(initModel.value.startWorkDate).substring(1,11)
                && JSON.stringify(model.value.usrBirthDate).substring(1,11) == JSON.stringify(initModel.value.usrBirthDate).substring(1,11)){
                    initModel.value.startWorkDate = model.value.startWorkDate
                    initModel.value.usrBirthDate = model.value.usrBirthDate
            }
            if(JSON.stringify(model.value) == JSON.stringify(initModel.value)){
                next(true)
            }else{
                isShow.value = true

            }
            toRouter.value = to
            if(isExitWithoutSave.value == 1){
                next(true)
            }
            if(isExitWithoutSave.value == 0){
                let flag = updateUsrPro(null)
                if(flag == true){
                    next(true)
                }else{
                    isShow.value = false
                }
                getUsrPro()
            }
            isExitWithoutSave.value = null
            next(false)
        })

        watch(isExitWithoutSave,(newVal,oldVal)=>{
            if(toRouter.value.name && (newVal == 1 || newVal == 0)){
                router.push({name:toRouter.value.name})
            }
        })

        watch(zipFeedBack,(newVal,oldVal) =>  {
            editAdr.value = true
        })

        return {
            edit: require('@/assets/icon/edit.svg'),
            select:require('@/assets/icon/select.svg'),
            selectActive:require('@/assets/icon/selectActive.svg'),
            alert: require('@/assets/icon/alert.svg'),
            clear: require('@/assets/icon/arrow_drop_down.svg'),
            model,
            isExitWithoutSave,
            isShow,
            userProjectShowFlag,
            emailFeedBack,
            emailExFeedBack,
            telFeedBack,
            postFeedBack,
            zipFeedBack,
            sexOptions,
            adrFeedBack,

            editEmail,
            editEmailEx,
            editGender,
            editBirthDate,
            editWorkDate,
            editMailFlg,
            editTel,
            editAdr,
            editNmKna,
            editType,
            typeOptions,

            showBirthDate,
            showWorkDate,
            showManageFlg,
            addressSearch,
            getUsrPro,
            updateUsrPro,
        }
    }
}
</script>

<style lang="scss" src="./css/usr_pro.scss" scoped />
<style lang="scss">
    input[type="month"]{
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 7px 8px;
        gap: 8px;
        width: 295px !important;
        min-width: 25px;
        height: 40px;
        background: #FFFFFF;
        border: 1px solid #2394F7!important;
        border-radius: 3px;
        font-weight: 300;
        font-size: 16px;
        line-height: 21px;
        color: #30353B;
        outline: none;
    }

</style>
